import { Command, HttpMethod } from "~/extensions/api";
export class PasswordReissue extends Command {
    constructor(model) {
        super(HttpMethod.Post, "auth/password/reissue");
        this.mailAddress = model.mailAddress;
    }
    mailAddress = "";
}
